import { Locale } from 'components/core/locale/types';

export const AccountPageTranslations = {
  [Locale.English]: {
    RelationshipPage: {
      pageTitle: 'Who would you like to get care for?',
      formTitle: 'Please select one:',
      nextButton: 'Next',
      meLabel: 'Me',
      childLabel: 'My child or teen',
      under17Eror:
        "We're sorry, we only treat patients between the ages of 1 and 17 right now.",
      exclusionText1:
        'We do our best to support everyone, but in certain situations Bend Health services may not be the most appropriate for {isSelf, select, true{you} false{your child or teen} other{}}.',
      exclusionText2:
        'Do any of these situations apply to {isSelf, select, true{you} false{your child/teen} other{}}?',
      npExclusionText2:
        'Do any of these situations apply to {isSelf, select, true{you} false{{name}} other{}}?',
      situationsTextDetox: 'DETOX FOR ALCOHOL OR ILLICIT DRUG USE',
      situationsTextHallucinations:
        'ACTIVE COMMAND HALLUCINATIONS, SEVERE THOUGHT DISORGANIZATION',
      situationsTextIntellectualDisability:
        'MODERATE - SEVERE INTELLECTUAL DISABILITY',
      situationsTextNeurocognitiveDisorder:
        'NEUROCOGNITIVE DISORDER WITH SEVERE MEMORY OR FUNCTIONING DIFFICULTIES',
      situationsTextEatingDisorder:
        'SEVERE EATING DISORDERS OR A BMI LESS THAN 18 DUE TO AN EATING DISORDER',
      situationsTextAutismSpectrumDisorder: 'SEVERE AUTISM SPECTRUM DISORDER',
      no: 'No',
      yes: 'Yes',
      exclusionConfirmTitle1: 'We’re sorry.',
      exclusionConfirmTitle2:
        'Bend Health is not the appropriate care option for your situation.',
      exclusionConfirmText1:
        'If you, your child or teen, or someone you know is in crisis, please call 911, go to the nearest emergency room, or reach out to the following national resources. You are never alone.',
      exclusionConfirmListText1: 'Call 988 to reach a 24 hour Crisis Center',
      exclusionConfirmListText2: 'Text 741741 to reach Crisis Text Line',
      exclusionConfirmText2:
        'Please come back to us if any of these situations have changed: ',
      exclusionConfirmText3:
        'Severe active eating disorder, active psychosis, active suicidal ideation with a plan, severe active self-harm, or severe active aggression, or no longer is need of detox.',
      exclusionConfirmTextBottom: 'Would you like to start over?',
    },
  },
};
